import { Outlet, useLocation, Navigate, useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { useContext, useEffect } from "react";
import { privateFetch } from "api/privateFetch";
import { ROUTES } from "routes";

export default function RequireAuth({ allowedRoles }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout, authState } = useContext(AuthContext);

  useEffect(() => {
    const requestIntercept = privateFetch.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${authState?.jwtToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = privateFetch.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (
          error?.response?.status === 401 &&
          error?.response?.data?.message === "User session expired" &&
          !prevRequest?.sent
        ) {
          prevRequest.sent = true;
          logout();
          navigate(ROUTES.LOGIN, { replace: true });
          return privateFetch(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      privateFetch.interceptors.request.eject(requestIntercept);
      privateFetch.interceptors.response.eject(responseIntercept);
    };
  }, []);

  return isAuthenticated() ? (
    allowedRoles.find((r) => r === authState?.userInfo?.userType) ? (
      <Outlet />
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    )
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}
